import { render } from "./AutoLogin.vue?vue&type=template&id=54264a49"
import script from "./AutoLogin.vue?vue&type=script&lang=js"
export * from "./AutoLogin.vue?vue&type=script&lang=js"
script.render = render

export default script